import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class VehicleClusterInformationDto {
  vehicleCheckInOdometerReadingMileage?: number = undefined
  vehicleCheckInOdometerReadingUnitOfMeasurement?: string = undefined
  convertCluster?: boolean = undefined
  clusterConversionInHouseOrThirdParty?: string = undefined
  thirdPartyClusterConversionCompany?: CompanyDto = undefined
  additionalProgramming?: boolean = undefined
  additionalProgrammingInHouseOrThirdParty?: string = undefined
  thirdPartyAdditionalProgrammingCompany?: CompanyDto = undefined
  clusterReinstallationOdometerReadingMi?: number = undefined
}

export const vehicleClusterInformationValidationSchema = yup.object({})
